<template>
  <div class="modal-card">
    <ValidationObserver ref="observer">
      <header class="modal-card-head">
          <p class="modal-card-title">Ingreso Trabajo diario</p>
      </header>
      <section class="modal-card-body">
        <div class="columns is-centered">
          <div class="column is-12">
            <h1 class="title is-2">{{daySelected}}</h1>
            <h2 class="subtitle is-3">Periodo {{order}} {{periodStrar}} - {{periodFinish}}</h2>
            <horse-selector :value="horseId" :rider-id="userId" :has-validator="true" rules="required" label="Caballo" name="horse" :params="{'active': true}" @select="selectedHorse = $event"/>
            <b-field grouped>
              <b-field label="Tipo de tarea" expanded>
                <task-selector :value="taskableId" name="task-type" @select="selectedTask = $event"/>
              </b-field>
              <b-field label="Ubicación" expanded>
                <location-selector :value="location" name="location" @select="selectedLocation = $event"/>
              </b-field>
            </b-field>
            <b-field label="Estado">
                <b-select placeholder="Select a name" v-model="taskComplete">
                    <option
                        v-for="option in tasksStatus"
                        :value="option.id"
                        :key="option.id">
                        {{ option.name }}
                    </option>
                </b-select>
            </b-field>
            <b-field label="Observación">
              <b-input type="textarea" v-model="observation"></b-input>
            </b-field>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
          <b-button @click="$parent.close()">Cancelar</b-button>
          <b-button type="is-primary" @click="save" :loading="isLoading">Guardar</b-button>
      </footer>
    </ValidationObserver>
  </div>
</template>

<script>
import HorseSelector from '@/components/HorseSelector'
import TaskSelector from '@/components/TaskSelector'
import LocationSelector from '@/components/LocationSelector'
import TaskUserService from '@/services/TaskUserService'

export default {
  components: {
    HorseSelector,
    TaskSelector,
    LocationSelector
  },
  props: {
    period: {
      type: Object,
      required: true
    },
    activity: {
      type: Object,
      required: false,
      default: null
    },
    day: {
      type: Object,
      required: true
    },
    userId: {
      type: Number,
      required: true
    }
  },
  created () {
    this.taskComplete = this.taskStatus
    this.observation = this.taskObservation
  },
  data () {
    return {
      selectedHorse: null,
      selectedLocation: null,
      selectedTask: null,
      taskComplete: 1,
      observation: null,
      isLoading: false,
      tasksStatus: [
        { id: 1, name: 'Pendiente' },
        { id: 2, name: 'En progreso' },
        { id: 3, name: 'Terminada' }
      ]
    }
  },
  methods: {
    toCapitalize (text) {
      return text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()
    },
    async save () {
      if (this.$refs.observer.validate()) {
        this.isLoading = true
        let data = {
          'training_id': this.selectedTask ? this.selectedTask.id : null,
          'user_id': this.userId,
          'horse_id': this.selectedHorse.id,
          'start_date': this.day.date,
          'start_at': this.period.start,
          'end_date': this.day.date,
          'end_at': this.period.finish,
          'location': this.selectedLocation ? this.selectedLocation.name : null,
          'observation': this.observation,
          'created_by': null,
          'task_user_status_id': this.taskComplete
        }
        try {
          let response = null
          let text = ''
          if (this.activity) {
            response = await TaskUserService.updateTaskUser(this.activity.id, data)
            text = 'Tarea creada exitosamente'
          } else {
            response = await TaskUserService.createTaskUser(data)
            text = 'Tarea editada exitosamente'
          }

          if (response.status >= 200 && response.status < 300) {
            this.success(text)
            this.$emit('saved')
          }
        } catch (error) {
          console.log(error)
          this.error()
        }
        this.isLoading = false
        this.$parent.close()
      }
    },
    success (text) {
      this.$buefy.toast.open({
        message: text,
        type: 'is-success'
      })
    },
    error () {
      this.$buefy.toast.open({
        message: 'No se pudo realizar los cambios',
        type: 'is-danger'
      })
    }
  },
  computed: {
    daySelected () {
      let formatDate = this.$moment(this.day.date, 'YYYY-MM-DD')
      let dayName = this.toCapitalize(this.day.name)
      let dayDate = formatDate.date()
      let month = formatDate.format('MMMM')
      return `${dayName} ${dayDate} de ${month}`
    },
    periodStrar () {
      return this.$moment(this.period.start, 'hh:mm:ss').format('LT')
    },
    periodFinish () {
      return this.$moment(this.period.finish, 'hh:mm:ss').format('LT')
    },
    order () {
      return this.period.order + 1
    },
    horseId () {
      return this.activity ? this.activity.horse_id : null
    },
    taskableId () {
      return this.activity ? this.activity.taskable_id : null
    },
    location () {
      return this.activity ? this.activity.location : null
    },
    taskStatus () {
      return this.activity ? this.activity.task_user_status_id : 1
    },
    taskObservation () {
      return this.activity ? this.activity.observation : null
    }
  },
  watch: {
    activity (value) {
      this.taskComplete = this.taskStatus
      this.observation = this.taskObservation
    }
  }
}
</script>

<style>
  /* .dropdown-menu{
    position: relative !important;
  } */
</style>
